// removed by extract-text-webpack-plugin
module.exports = {"subscriptionSuccessBox":"_39pQX36c_9pQ-WY-tkCTbg","subscriptionSuccessBoxInner":"_2Snj2eFcUrndjfRJO0jlwA","button":"_2shuThaxmrySqu4cV9B0ET","container":"_108SwXdUFkwJ3AcjiVJ1M8","iconContainer":"_2rGBksbJ0qhPd5u3RAq1k9","icon":"_2qllB2PppKvY3OdgLWW1Zr","megascans":"_3_DdrFPSJw4U5_TKBRMfhh"};


//////////////////
// WEBPACK FOOTER
// ./src/EpicMigration/components/SubscriptionSuccessBox.scss
// module id = 2974
// module chunks = 0